module.exports = __webpack_public_path__ + "img/Pediatrics.b0fbff56.svg";